<template>
  <div
    class="tab-pane fade show active"
    id="pills-1"
    role="tabpanel"
    aria-labelledby="pills-1-tab"
  >
    <div class="tourn-banner my-4">
      <div class="card flex-md-row justify-content-md-between">
        <div class="col-md-4 card-img-wrapper order-md-2">
          <!-- <img
            :src="
              tourbinary &&
              tourbinary[0] &&
              tourbinary[0].filepath_web
                | get_img(
                      'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                    )
            "
          /> -->
          <div class="image"
              :style="{
                  backgroundImage: `url(${
                      (tourbinary &&
                      tourbinary[0] &&
                      tourbinary[0].filepath_web)
                      ? $options.filters.get_img(tourbinary[0].filepath_web)
                      : 'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                  })`
              }">
          </div>
        </div>

        <div class="col-md-8 d-flex flex-column order-md-1">
          <div class="card-body">
            <p class="badge-group">
              <span class="badge tourn-type">
                {{ tournament_type(tournamentinfo.type) }}
              </span>
              <span class="badge tourn-game-type">
                {{ game_type(tournamentinfo.gametype_fk) }}
              </span>
            </p>
            <h3 class="tourn-title line-clamp-clear">
              {{ tournamentinfo.title }}
            </h3>
            <p class="tourn-rank-type">
              <!-- {{ game_type(tournamentinfo.gametype_fk) }} <strong>&middot;</strong>  -->
              {{ tournamentinfo.tour_rank_type | tour_rank_type }}
            </p>
          </div>

          <div class="card-footer">
            <div class="row gx-2 gy-1">
              <div
                class="col-auto text-date"
                v-if="
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_private
                "
              >
                <!-- 사용자 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-orange"
                  title="Connect time"
                  >CT</dfn
                >
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_private
                    | dateformat
                }}
                ~
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_enddate.timezone_private | dateformat
                }}
              </div>
              <div
                class="col-auto text-date"
                v-else-if="
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_common
                "
              >
                <!-- 서비스 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_startdate.timezone_common | dateformat
                }}
                ~
                {{
                  tournamentinfo.timezone_startdate &&
                  tournamentinfo.timezone_enddate.timezone_common | dateformat
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p
      class="pt-1 text-subscript text-info"
      v-if="tournamentinfo.gametype_fk == 9"
    >
      <span class="material-icons-outlined">info</span>
      {{ $t("text.common.offline_scramble_txt") }}
    </p>

    <div class="border-top-dgray mt-4">
      <div class="row g-0 border-bottom">
        <div class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center">
          <label class="d-table-cell">{{
            $t("title.tournament.tournament_participation_type")
          }}</label>
        </div>
        <div class="col-8 col-lg-10 d-flex">
          <p class="d-table-cell align-self-center">
            {{ $t("text.common.participation") }}
            {{
              tournament_particiaption_type(tournamentinfo.participationtype_fk)
            }}
          </p>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center">
          <label class="d-table-cell">{{
            $t("title.common.information")
          }}</label>
        </div>
        <div class="col-8 col-lg-10 d-flex">
          <p class="d-table-cell align-self-center">
            {{ tournamentinfo.remark }}
          </p>
        </div>
      </div>
      <div class="row g-0 border-bottom">
        <div class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center">
          <label class="d-table-cell">{{ $t("title.common.course") }}</label>
        </div>
        <div class="col-8 col-lg-10 d-flex">
          <p class="d-table-cell align-self-center">
            <span v-for="(course, index) in tournamentcourse" :key="index"
              >{{ index === 0 ? "" : ", " }}{{ course.coursename }}</span
            >
          </p>
        </div>
      </div>

      <div class="row g-0 border-bottom">
        <div class="row g-0 col-4 col-lg-2 bg-gray align-item-center">
          <label class="d-table-cell align-self-center">{{
            $t("text.common.shortcourse")
          }}</label>
        </div>
        <div v-if="subcourselistcnt" class="col-8 col-lg-10">
          <div
            v-for="(anc, index1) in subcourselist"
            :key="'k_' + index1"
            class="subcourse"
          >
            <h6>{{ anc.subcoursename }}</h6>
            <small class="d-block text-dgray"
              >{{ $t("text.common.shortcourse") }} {{ anc.subcourseseq }}</small
            >
          </div>
        </div>
      </div>
      <div class="row g-0 border-bottom" v-if="tournamentinfo.gametype_fk == 1">
        <div class="row g-0 col-4 col-lg-2 bg-gray align-item-center">
          <label class="d-table-cell align-self-center">{{
            $t("title.common.point_allocation")
          }}</label>
        </div>
        <div class="col-8 col-lg-10 d-flex">
          <p class="d-table-cell align-self-center">
            <span>
              {{ tournamentinfo.tour_class | tour_class }}
              {{ $t("title.common.standard_point") }}
              {{
                tournamentinfo.oom_point == 1
                  ? "+ " + $t("title.common.oom_point")
                  : ""
              }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="border-top-dgray mt-5">
      <!-- <div class="row g-0">
        <div class="col-lg-2 row g-0 bg-gray border-bottom align-items-center">
          <label class="d-table-cell">매장</label>
        </div>
        <div class="col-lg-10 border-bottom">
          <p class="d-table-cell">
            <span v-for="(shop, index2) in tournamentshop" :key="index2"
              >{{ index2 === 0 ? "" : " / " }}{{ shop.shopname }}</span
            >
          </p>
        </div>
      </div> -->
      <div class="row g-0">
        <div class="col-lg-2 row g-0 bg-gray border-bottom align-items-center">
          <label class="d-table-cell">{{ $t("title.common.prizes") }}</label>
        </div>
        <div class="col-lg-10 border-bottom">
          <div class="row g-0 border-bottom">
            <div class="col-lg-12">
              <p class="d-table-cell">
                {{ tournamentprizeetc.etcprize || "Unregistered" }}
              </p>
            </div>
          </div>
          <div class="row g-0 border-bottom-0">
            <div class="col-lg-12">
              <p class="d-table-cell">
                <span
                  class="d-block"
                  v-for="(rank, index3) in tournamentprizerank"
                  :key="index3"
                  ><strong class="fw-500 text-black"
                    >{{ $t("text.common.top") }} {{ rank.rankno }}</strong
                  >
                  :
                  <span class="text-prize">{{ rank.rankprize | comma }}</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-0" v-if="tournamentinfo.gametype_fk == 1">
        <div class="col-lg-2 bg-gray row g-0 align-items-center border-bottom">
          <label class="d-table-cell">{{
            $t("title.common.tournament_conditions")
          }}</label>
        </div>
        <div class="col-lg-10">
          <div class="row g-0 border-bottom-0">
            <div
              class="col-lg-6 d-table-cell d-flex flex-column align-items-stretch"
            >
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.game_mode")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ tournamentinfo.mode }}
                  </p>
                </div>
              </div>
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.level")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ tournament_level(tournamentinfo.level) }}
                  </p>
                </div>
              </div>
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.greenspeed")
                  }}</label>
                </div>
                <div class="col-8">
                  <p class="d-table-cell">
                    {{ tournamentinfo.greenspeed_fk | greenspeed }}
                  </p>
                </div>
              </div>
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.entry_limit")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center text-red">
                    {{ tournamentinfo.entrylimit | transToValue("∞") }}
                  </p>
                </div>
              </div>
              <div
                class="row g-0 border-bottom d-flex flex-row align-items-stretch h-100"
              >
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.mulligan")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ tournamentinfo.mulligan }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 d-table-cell d-flex flex-column align-items-stretch"
            >
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.play_format")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ tournamentinfo.hole }}H
                  </p>
                </div>
              </div>
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.wind")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">{{ wind }}</p>
                </div>
              </div>
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.greengravity")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ tournamentinfo.greengravity_fk | greengravity }}
                  </p>
                </div>
              </div>
              <div class="row g-0 border-bottom">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.tournament.rank_type")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ tournamentinfo.tour_rank_type | tour_rank_type }}
                  </p>
                </div>
              </div>
              <div class="row g-0 border-bottom flex-grow-1">
                <div class="col-4 bg-lightgray row g-0 align-items-center">
                  <label class="d-table-cell">{{
                    $t("title.common.teebox")
                  }}</label>
                </div>
                <div class="col-8 d-flex">
                  <p class="d-table-cell align-self-center">
                    {{ $t("title.common.male") }}: {{ teemale }}<br />
                    {{ $t("title.common.female") }}: {{ teefemale }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row g-0 border-bottom-0">
            <div class="col-lg-3 bg-gray row align-items-center">
              <label class="d-table-cell">Handicap(No. of Play)</label>
            </div>
            <div class="col-lg-9">
              <p class="d-table-cell">{{ tournamentinfo.playhandicap }}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <b-toast
      id="toast-require-login"
      toaster="position-fixed top-50 start-50 translate-middle"
      no-close-button
      no-auto-hide
      solid
      body-class="p-4 text-center"
    >
      <div class="avatar avatar-lg mt-2 bg-orange border-0">
        <h3 class="material-icons text-white">person</h3>
      </div>
      <h6 class="sub-title mt-3 mb-2">{{ $t("text.common.require_login") }}</h6>
      <p class="pt-1">{{ $t("text.common.go_login_page") }}</p>
      <div class="btn-bottom-wrapper mt-3">
        <b-button
          size="sm"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvToast.hide('toast-require-login')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          :aria-label="$t('button.common.login')"
          @click="$router.push('/Login')"
        >
          {{ $t("button.common.login") }}
        </b-button>
      </div>
    </b-toast>
    <b-modal
      id="modal-entry-fee-payment"
      @shown="onModalShown"
      ref="modal-entry-fee-payment"
      size="md"
      centered
      scrollable
      no-close-on-backdrop
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("text.common.entry_fee_payment") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
        </b-button>
      </template>
      <template v-if="pay_flag == '1'">
        <p class="modal-subtitle lh-sm">
          {{ paytournamentinfo.tourdefine.title }}
        </p>
        <b-form
          class="row row-cols-sm-auto g-2 justify-content-end"
        >
          <div class="row g-0 table-type header-col p-keep">
            <div class="col-sm-4">
              {{ $t("title.common.player") }}
            </div>
            <div class="col-sm-8">
              <p class="d-flex flex-wrap">
                <strong class="me-1">{{ $t("text.common.id") }}</strong>
                <span>: {{ paytournamentinfo.player.player_id }}</span>
              </p>
              <p class="d-flex flex-wrap mt-1">
                <strong class="me-1">{{ $t("title.common.nickname") }}</strong>
                <span class="text-nickname"
                  >: {{ paytournamentinfo.player.nickname }}</span
                >
              </p>
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.entry_limit") }}
            </div>
            <div class="col-sm-8 text-red">
              {{ paytournamentinfo.tour_results.total_game || 0 }} /
              {{ paytournamentinfo.tourdefine.entrylimit | transToValue("∞") }}
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.product_name") }}
            </div>
            <div class="col-sm-8">
              {{ product.name }}
            </div>

            <div class="col-sm-4">
              {{ $t("title.tournament.description") }}
            </div>
            <div class="col-sm-8">
              {{ product.description }}
            </div>
            <div class="col-sm-4">
              {{ $t("text.common.entry_fee") }}
            </div>

            <template v-if="coupon && coupon.id">
              <div class="col-sm-8">
                <span class="origin-price">
                  {{ product.amount | stripe_unit_amount(product.currency) }}
                </span>
                <span class="text-blue" v-if="coupon.percent_off">
                  {{ coupon.discounted_amount | stripe_unit_amount(product.currency) }}
                   ({{coupon.percent_off }}% off)
                </span>
                <span class="text-blue" v-if="coupon.discounted_amount">
                  {{ coupon.discounted_amount | stripe_unit_amount(product.currency) }}
                   ({{coupon.discounted_amount | stripe_unit_amount(product.currency) }} off)
                </span>
                <p class="text-red fw-500 lh-120 fs-12" v-if="coupon.discounted_amount < 50">
                   Please note: A minimum payment of $0.50 AUD is required even if your total is $0 (after discounts or coupons).
                </p>
              </div>

            </template>
            <div class="col-sm-8" v-else>
              <p>
                {{ product.amount | stripe_unit_amount(product.currency) }}
              </p>
            </div>
            <template v-if="product && product.is_promotion">
              <div class="col-sm-4">
                {{ $t("title.common.coupon") }}
              </div>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control "
                    :placeholder="$t('title.common.coupon_code')"
                    :aria-label="$t('title.common.coupon_code')"
                    autocomplete="off"
                    v-model="couponCode"
                  />
                  <button
                    class="btn btn-primary btn-md "
                    type="button"
                    id="id"
                    @click="coupon_check(paytournamentinfo.tourdefine && paytournamentinfo.tourdefine.tour_pk)"
                  >
                    {{ $t("button.common.apply") }}
                  </button>
                </div>
              </div>
            </template>

            <div class="col-sm-4">
              {{ $t("text.common.card_info") }}
            </div>
            <div class="col-sm-8">
              <div class="row g-2">
                <div class="col-12" id="card-number-element">
                  <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="1234 1234 1234 1234"
                    :aria-label="$t('text.common.card_number')"
                    name="CardNumber"
                    autocomplete="off"
                  /> -->
                </div>
                <div class="col-6" id="card-expiry-element">
                  <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="MM / YY"
                    :aria-label="$t('text.common.card_expiry')"
                    name="CardExpiry"
                    autocomplete="off"
                  /> -->
                </div>
                <div class="col-6" id="card-cvc-element"></div>
              </div>
            </div>

            <div class="col-sm-4">
              {{ $t("text.common.zip_code") }}
            </div>
            <div class="col-sm-8">
              <div class="row g-2">
                <!-- <div class="col-12">
                  <select name="countryno">
                    <option value="">{{ $t("title.common.choose") }}</option>
                  </select>
                </div> -->
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    :placeholder="$t('text.common.zip_code')"
                    :aria-label="$t('text.common.zip_code')"
                    name=""
                    autocomplete="off"
                    v-model="postalCode"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </template>
      <!-- 결제 정상 완료 -->
      <template v-if="pay_flag == '2'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-success">check_circle</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_complete") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_successfully") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment_method") }}
              </div>
              <div class="col-sm-8">
                {{
                  (pay_result.paymentIntent.payment_method_types &&
                    pay_result.paymentIntent.payment_method_types.join(", ")) ||
                  ""
                }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment_amount") }}
              </div>
              <div class="col-sm-8">
                {{
                  pay_result.paymentIntent.amount
                    | stripe_unit_amount(pay_result.paymentIntent.currency)
                }}
                <p class="text-red fw-500 lh-120 fs-12" v-if="pay_result.paymentIntent.amount <= 50">
                   Please note: A minimum payment of $0.50 AUD is required even if your total is $0 (after discounts or coupons).
                </p>
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment") }} {{ $t("text.common.number") }}
              </div>
              <div class="col-sm-8">{{ pay_result.paymentIntent.id }}</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.date") }}
              </div>
              <div class="col-sm-8 text-date">
                {{ (pay_result.paymentIntent.created * 1000) | dateformat }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.company") }}
              </div>
              <div class="col-sm-8">XGAU</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 참가 제한 초과 -->
      <template v-if="pay_flag == '3'">
        <div class="my-5 text-center">
          <p class="material-icons fs-48 text-orange">report</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ pay_fail_message }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.participate_another_tourn") }}
          </p>
        </div>
      </template>
      <!-- 결제 실패 -->
      <template v-if="pay_flag == '4'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-danger">dangerous</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_failed") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_unsuccessful") }}<br />
            {{ $t("text.common.please_try_again") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.code") }}
              </div>
              <div class="col-sm-8">404</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.reason") }}
              </div>
              <div class="col-sm-8">Card Company Failure</div>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button> -->

        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.confirm')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.confirm") }}
        </b-button> -->

        <b-button
          size="md"
          v-if="pay_flag == '1'"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>

        <b-button
          size="md"
          v-else-if="pay_flag == '2'"
          variant="outline-secondary"
          :aria-label="$t('button.common.done')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.done") }}
        </b-button>

        <b-button
          size="md"
          v-else
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button>

        <b-button
          v-if="pay_flag == '1'"
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.submit')"
          type="button"
          @click="onPaySubmit"
        >
          {{ $t("button.common.submit") }}
        </b-button>

        <!-- <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.try_again')"
        >
          {{ $t("button.common.try_again") }}
        </b-button> -->
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/tournament";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "TournamentCondition",
  data() {
    return {
      tournamentno: this.$route.params.id,
      tournamentinfo: [
        {
          title: "",
          remark: "",
          startdate: "",
          enddate: "",
          mode: "",
          hole: "",
          level: "",
          wind: "",
          mulligan: "",
          entrylimit: "",
          teeboxman: "",
          teeboxwoman: "",
          playhandicap: "",
        },
      ],
      tournamentcourse: [],
      tournamentshop: [],
      tournamentprizeetc: [
        {
          etcprize: "",
        },
      ],
      tournamentprizerank: [],

      wind: "",
      teemale: "",
      teefemale: "",
      subcourselist: [],
      tourbinary: [],
      subcourselistcnt: 0,
      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      postalCode: "",
      couponCode: "",
      product: {},
      coupon: {},
      pay_result: { paymentIntent: {} },

      _stripe: {},
      pay_flag: 1,
      pay_fail_message: "",
      login: sessionStorage.getItem("token") ? true : false,
      paytournamentinfo: {
        player: {},
        tour_results: {},
        tourdefine: {},
        tour_order_list: [],
      },
    };
  },
  methods: {
    async onModalShown() {
      // 모달이 열리고 나서 mount 실행
      if (!this.stripe) {
        this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
      }

      this.elements = this.stripe.elements();

      this.cardNumber = this.elements.create("cardNumber");
      this.cardNumber.mount("#card-number-element");

      this.cardExpiry = this.elements.create("cardExpiry");
      this.cardExpiry.mount("#card-expiry-element");

      this.cardCvc = this.elements.create("cardCvc");
      this.cardCvc.mount("#card-cvc-element");
    },

    participation(tour_pk) {
      if (!this.login) {
        this.$bvToast.show("toast-require-login");
        return false;
      }


      this._stripe = {};
      this.stripe = null;
      this.elements = null;

      // 2. 카드 입력 필드 관련 초기화
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
      this.postalCode = "";

      // 3. 쿠폰 및 상품 정보 초기화
      this.couponCode = "";
      this.coupon = {};
      this.product = {};

      // 4. 결제 결과 및 플래그 초기화
      this.pay_result = { paymentIntent: {} };
      this.pay_flag = 1;
      this.pay_fail_message = "";

      // 5. 대회 및 사용자 관련 복합 객체 초기화
      this.paytournamentinfo = {
        player: {},
        tour_results: {},
        tourdefine: {},
        tour_order_list: [], // 배열은 빈 배열로
      };

      this.post_stripeinit(tour_pk);
    },

    participation_no() {
      alert(this.$i18n.t("alert.common.offline"));
      return false;
    },

    post_stripeinit(tour_pk) {
      ax.post_stripeinit(tour_pk, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.paytournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;

          this.pay_flag = 1;
          this.$bvModal.show("modal-entry-fee-payment");
        } else {
          this.pay_flag = 3;
          this.pay_fail_message = data.message || "";
          this.$bvModal.show("modal-entry-fee-payment");
        }
      });
    },
    async onPaySubmit(event) {
      event.preventDefault();

      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.cardNumber,
        billing_details: { address: { postal_code: this.postalCode } },
      });

      if (error) return alert(error.message);

      ax.post_stripe_confirm(
        this.tour_pk,
        { product_id: this.product.id, paymentmethod_id: paymentMethod.id, coupon_code: this.couponCode },
        async (flag, data) => {
          this._stripe = data.stripe;
          // console.log("this.product", this.product);

          if (flag) {
            this.pay_result = await this.stripe.confirmCardPayment(
              this._stripe.client_secret
            );
            // console.log("this.paymentIntent", this.pay_result.paymentIntent);
            if (this.pay_result.error) {
              alert(this.pay_result.error.message);
            } else if (this.pay_result.paymentIntent.status === "succeeded") {
              const charges = this.pay_result.paymentIntent.charges
                ? this.pay_result.paymentIntent.charges.payment_method_details
                    .card
                : "";
              ax.post_order_insert(
                this.tour_pk,
                {
                  charges: JSON.stringify(charges),
                  payment_intent_id: this.pay_result.paymentIntent.id,

                  product: JSON.stringify({
                    amount: this.product.amount,
                    actual_amount: this.pay_result.paymentIntent.amount,
                    id: this.product.id,
                    name: this.product.name,
                    price_id: this.product.price_id,
                    currency: this.product.currency,
                    coupon_code: this.couponCode,
                  }),
                },
                (flag, data) => {
                  // console.log(flag, data);

                  if (flag) {
                    this.pay_flag = 2;
                  } else {
                    this.pay_flag = 3;
                    this.pay_fail_message = data.message || "";
                    // alert(data.message);
                  }
                }
              );
            }
          } else {
            alert(data.message);
          }
        }
      );
    },
    get_tournamentcondition() {
      ax.get_tournamentcondition(this.tournamentno, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.tournamentinfo = data.tournamentinfo;
          this.tournamentcourse = data.tournamentcourse;
          this.tournamentshop = data.tournamentshop;
          this.tournamentprizeetc = data.tournamentprizeetc;
          this.tournamentprizerank = data.tournamentprizerank;

          this.subcourselist = data.subcourselist;
          this.subcourselistcnt = data.subcourselistcnt;
          this.tourbinary = data.tourbinary;
          this.change_wind(this.tournamentinfo.wind);
          this.change_male(this.tournamentinfo.teeboxman);
          this.change_female(this.tournamentinfo.teeboxwoman);
        } else {
          alert(data.message);
        }
      });
    },
    coupon_check(tour_pk) {

      if (this.couponCode === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.coupon"),
          })
        );
        return false;
      }

      ax.post_stripe_coupon(tour_pk, { couponCode: this.couponCode }, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.paytournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;
          this.coupon = data.coupon;
          console.log('data.product', data.product);
          // this.pay_flag = 1;
          // this.$bvModal.show("modal-entry-fee-payment");
        } else {
          alert(data.message);
          this.couponCode = "";
          // this.pay_flag = 3;
          // this.pay_fail_message = data.message || "";

          // this.$bvModal.show("modal-entry-fee-payment");
        }
      });

    },
    // change_wind(wind) {
    //   if (wind === "0") {
    //     this.wind = this.$i18n.t("text.common.calm");
    //   } else if (wind === "1") {
    //     this.wind = this.$i18n.t("text.common.light");
    //   } else if (wind === "2") {
    //     this.wind = this.$i18n.t("text.common.moderate");
    //   } else if (wind === "3") {
    //     this.wind = this.$i18n.t("text.common.strong");
    //   } else if (wind === "4") {
    //     this.wind = this.$i18n.t("text.common.random");
    //   } else {
    //     this.wind = wind;
    //   }
    // },
    // change_male(teeboxman) {
    //   if (teeboxman === "1") {
    //     this.teemale =
    //       this.$i18n.t("text.common.pro") +
    //       "(" +
    //       this.$i18n.t("text.common.blue") +
    //       ")";
    //   } else if (teeboxman === "2") {
    //     this.teemale =
    //       this.$i18n.t("text.common.regular") +
    //       "(" +
    //       this.$i18n.t("text.common.white") +
    //       ")";
    //   } else if (teeboxman === "3") {
    //     this.teemale =
    //       this.$i18n.t("text.common.lady") +
    //       "(" +
    //       this.$i18n.t("text.common.red") +
    //       ")";
    //   } else {
    //     this.teemale = teeboxman;
    //   }
    // },
    // change_female(teeboxwoman) {
    //   if (teeboxman === "1") {
    //     this.teemale =
    //       this.$i18n.t("text.common.pro") +
    //       "(" +
    //       this.$i18n.t("text.common.blue") +
    //       ")";
    //   } else if (teeboxman === "2") {
    //     this.teemale =
    //       this.$i18n.t("text.common.regular") +
    //       "(" +
    //       this.$i18n.t("text.common.white") +
    //       ")";
    //   } else if (teeboxman === "3") {
    //     this.teemale =
    //       this.$i18n.t("text.common.lady") +
    //       "(" +
    //       this.$i18n.t("text.common.red") +
    //       ")";
    //   } else {
    //     this.teefemale = teeboxwoman;
    //   }
    // },
  },

  created() {
    this.get_tournamentcondition();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  mixins: [myMixin],
};
</script>
<style lang="scss" scoped>
#card-number-element,
#card-expiry-element,
#card-cvc-element {
  border: 1px solid #cdcfd1;
  padding: 10px 10px;
  background-color: #fff;
  height: 40px;
  box-sizing: border-box;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

#card-expiry-element,
#card-cvc-element {
  width: 49%;
}

#card-cvc-element {
  margin-left: 5px;
}
</style>
